import { Fragment, useState } from "react";
import { Button } from "react-bootstrap";
import { Trash, EyeFill, Link45deg, Paperclip } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import FindLinkInText from "../store/api/CommonFunctions";

const TableRow = (props) => {
    const { row, onclick, cols, indx, buttons } = props;
    const [dispalyDetail, setDisplay] = useState(false);
    let mobileCols = cols.filter(c => c.justInMobile && c.colName.toLowerCase() !== "rownumber");
    let webCols = cols.filter(c => !c.justInMobile && c.colName.toLowerCase() !== "rownumber");
    const rowNumber = cols.find(c => c.colName.toLowerCase() === "rownumber");
    const rowClick = (item) => {
        if (window.innerWidth <= 414) {
            setDisplay(!dispalyDetail);
        }
        else {
            if (onclick) {
                onclick(item);
            }
        }
    }
    return (

        <Fragment key={indx}>
            <tr className="resultTableRow" onClick={() => rowClick(row)} style={{backgroundColor: indx%2 !== 0?"#e9e9e9":"#FFF"}}>
                {rowNumber && <td style={{ width: "40px" }}>{indx + 1}</td>}
                {mobileCols.map((item, i) => {
                    return (item.showCondition === undefined || item.showCondition() === true) &&
                        <td key={i} style={item.style ? item.style : item.styleCondition ? item.styleCondition(row) : {}} className={item.hasTooltip ? "tooltipCol" : ""}>
                            {item.colType === "currency" && (!row[item.colName] ? 0 : row[item.colName].toLocaleString(navigator.language, { minimumFractionDigits: 0 }))}
                            {item.colType === "boolean" && <input type="checkbox" checked={row[item.colName]} readOnly />}
                            {item.colType === "number" && row[item.colName]}
                            {item.colType === "string" &&
                                (item.hasLink ? < FindLinkInText text = {row[item.colName]?.substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : "")}/> :
                                (row[item.colName]?.substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : "")))}
                            {!item.colType && row[item.colName]}
                            {item.hasTooltip && row[item.colName] && item.maxTextLength < row[item.colName].length && <span className="tooltipSpan">{row[item.colName]}</span>}
                        </td>
                })}
                {
                    window.innerWidth > 414 &&
                    <Fragment>
                        {webCols &&
                            webCols.map((item, i) => {
                                return (item.showCondition === undefined || item.showCondition() === true) &&
                                    <td key={i} style={item.style ? item.style : item.styleCondition ? item.styleCondition(row) : {}} className={item.hasTooltip ? "tooltipCol" : ""}>
                                        {item.colType === "currency" && (!row[item.colName] ? 0 : row[item.colName].toLocaleString(navigator.language, { minimumFractionDigits: 0 }))}
                                        {item.colType === "boolean" && <input type="checkbox" className="form-check-input" checked={row[item.colName]} readOnly />}
                                        {item.colType === "number" && row[item.colName]}
                                        {item.colType === "string" && row[item.colName] &&
                                            (item.hasLink ? <FindLinkInText text={row[item.colName].substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : "")}/>:
                                                row[item.colName].substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : ""))}
                                        {!item.colType && row[item.colName]}
                                        {item.hasTooltip && row[item.colName] && item.maxTextLength < row[item.colName].length && <span className="tooltipSpan">{row[item.colName]}</span>}
                                    </td>
                            })
                        }
                        {
                            buttons &&
                            <td >
                                {buttons.map((b, i) => {
                                    return (
                                        (b.showCondition === undefined || b.showCondition(row) === true) &&
                                        <Fragment key={i}>

                                            {b.type === "delete" &&
                                                <Trash className="rowBtn" color="red" size={18} onClick={(e) => { b.onclick({ e, ...row }) }} />
                                            }
                                            {b.type === "show" &&
                                                <EyeFill className="rowBtn" style={{ marginRight: "3px" }} color="#9377d1" size={18} onClick={(e) => { b.onclick({ e, ...row }) }} />
                                            }
                                            {b.type === "attach" &&
                                                <Paperclip className="rowBtn" style={{ marginRight: "3px" }} color="blue" size={18} onClick={(e) => { b.onclick({ e, ...row }) }} />
                                            }
                                            {b.type === "related" &&
                                                <Link45deg className="rowBtn" style={{ marginRight: "3px" }} color="blue" size={18} onClick={(e) => { b.onclick({ e, ...row }) }} />
                                            }
                                            {b.type === "common" &&
                                                <button className={"btn" + (b.tooltip ? " tooltipBtn" : "")} style={{ padding: 0, marginRight: "3px" }} onClick={(e) => { b.onclick({ e, ...row }) }}>
                                                    {b.tooltip !== undefined && <span className="btnTooltip">{b.tooltip}</span>}
                                                    {b.icon}
                                                </button>
                                            }
                                            {b.type === "link" &&
                                                <Link onClick={(e) => { b.onclick({ e, ...row }) }}>{b.icon}</Link>
                                            }
                                            {!b.type &&
                                                <Button style={{ marginRight: "3px" }} onClick={(e) => { b.onclick({ e, ...row }) }} className={"rowBtn " + b.className ?? ""}>{b.title}</Button>
                                            }


                                        </ Fragment>)
                                })}
                            </td>
                        }
                    </Fragment>
                }
            </tr>
            {
                window.innerWidth <= 414 &&
                <tr style={{ display: dispalyDetail ? "table-row" : "none" }}>
                    <td colSpan={mobileCols?.length + (rowNumber ? 1 : 0)} style={{ border: "1px solid #a7aab6", borderRadius: "2px" }}>
                        <div className='row'>
                            {webCols.map((item, i) => {
                                return (
                                    <Fragment key={i}>
                                        <div className="col-5 mt-0" style={{ padding: "5px", paddingRight: "8px" }}> {item.colTitle}:</div>
                                        <div className="col-7 mt-0" style={{ padding: "5px" }}>
                                            {item.colType === "currency" && row[item.colName]?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                            {item.colType === "boolean" && <input type="checkbox" readOnly checked={row[item.colName] ?? false} />}
                                            {item.colType === "string" && row[item.colName] &&  (item.hasLink ? <FindLinkInText text={row[item.colName].substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : "")}/>:
                                                row[item.colName].substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : ""))}
                                            {item.colType === "number" && row[item.colName]}
                                            {!item.colType && row[item.colName]}
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </div>
                        <div className="row" style={{ padding: "5px", paddingRight: "10px" }}>
                            <div className="col-md-4" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                {buttons && buttons.map((b, i) => {
                                    return ((b.showCondition === undefined || b.showCondition(row) === true) && <Button key={"btn" + i} onClick={(e) => { b.onclick({ ...row, e }) }} className={b.className + " mt-1"}>{b.title}</Button>)
                                }
                                )}
                            </div>
                        </div>
                    </td>
                </tr>

            }
        </Fragment>
    );
}
export default TableRow;